import config from "../config"
const baseUrl = config.base_url + "lz_tree_image/"
export default {
    imagesByTreeId: {
        url: baseUrl + "imagesByTreeId/{treeId}/{limit}?key=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9",
        type: "get",
    }
}
